<template>
	<div :class="getClass()">
		<apexchart width="100%" type="line" :options="options" :series="series"></apexchart>
	</div>
</template>

<script>
export default {
	props: {
		types: Array,
		data: Array,
		negative: Boolean
	},
	mounted() {
		this.types.map((t, i) => {
			return {
				name: t.name,
				values: this.data.map(item => item.values[i])
			};
		});
	},
	methods: {
		getClass: function() {
			if (this.negative) {
				return "bar-graph-negative";
			} else {
				return "bar-graph-positive";
			}
		}
	},
	data() {
		return {
			options: {
				chart: {
					toolbar: {
						show: false
					}
				},
				colors: this.types.map(type => type.color),
				dataLabels: {
					enabled: true
				},
				xaxis: {
					categories: this.data.map(item => item.name)
				}
			},
			series: this.types.map((type, index) => ({
				name: type.name,
				type: "column",
				// data: [1 + index, 4 + index, 5 + index, 10 + index]
				data: this.data.map(item => item.values[index])
			})),
			// series: [
			// 	{
			// 		name: "Composite",
			// 		type: "column",
			// 		data: [1, 4, 5, 10]
			// 	},
			// 	{
			// 		name: "Amalgam",
			// 		type: "column",
			// 		data: [1, 4, 5, 10]
			// 	},
			// 	{
			// 		name: "GIC",
			// 		type: "column",
			// 		data: [1, 4, 5, 10]
			// 	}
			// ],
			stroke: {
				width: [4, 4, 4]
			},
			plotOptions: {
				bar: {
					columnWidth: "20%"
				}
			},
			tooltip: {
				shared: false,
				intersect: true,
				x: {
					show: false
				}
			},
			legend: {
				horizontalAlign: "left",
				offsetX: 40
			}
		};
	}
};
</script>
